import { Action } from '@ngrx/store';
import { Consent } from '../model/consent.model';

export const LOAD_REQUEST = '[Consent] Load Request';
export const LOAD_SUCCESS = '[Consent] Load Success';
export const LOAD_ERROR =   '[Consent] Load Error';

/**
 * Request to fetch consent.
 */
export class LoadRequestAction implements Action {
    readonly type = LOAD_REQUEST;
}

/**
 * User profile successfuly fetched.
 */
export class LoadSuccessAction implements Action {
    readonly type = LOAD_SUCCESS;

    constructor(public payload: Consent) {}
}

/**
 * Error when fetching consent.
 */
export class LoadErrorAction implements Action {
    readonly type = LOAD_ERROR;

    constructor(public payload: any) { }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions
    = LoadRequestAction
    | LoadSuccessAction
    | LoadErrorAction;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/consent/actions/consent.actions.ts